import "bxslider/dist/jquery.bxslider"
import "bxslider/dist/jquery.bxslider.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "ol/ol.css"

// Should be merged with styles/ in the future
import "./styles-2018/style.scss"

import "@adyen/adyen-web/styles/adyen.css"

import "./pages/content"
import "./password"

import $ from "jquery"

$(document).ready(() => {
  $(".js-product-slider").each((_i, e) => {
    var $e

    $e = $(e)
    $e.bxSlider({
      slideWidth: 385,
      maxSlides: $e.data("max-slides"),
      slideMargin: 0,
      moveSlides: 1,
      pager: false,
      controls: $e.data("controls"),
      onSliderLoad: () => {
        $(".area__slider").css({ visibility: "visible" })
      },
    })
  })
})
